import React from 'react';
import WspForm from './form';

const WspNew = () => {
    return <WspForm />;
};

export default WspNew;
